import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import PanelContext from '../../sidebar/panel/panelContext';
import ArticleActions from '../../articleActions/articleActions';
import ViewAtPublisherAnchor from '../../articleActions/actionTypes/viewAtPublisherAnchor';
import { DoiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';

export default function DoiArticlePreviewActions({ doi, viewAtPublisherEventData }) {
  const { getId } = useContext(PanelContext);
  const id = `view-button-doi-${encodeURIComponent(doi)}-${getId()}`;

  return (
    <ArticleActions>
      <ViewAtPublisherAnchor
        id={id}
        doi={doi}
        viewAtPublisherEventData={viewAtPublisherEventData}
      />
    </ArticleActions>
  );
}

DoiArticlePreviewActions.propTypes = {
  doi: PropTypes.string.isRequired,
  viewAtPublisherEventData: DoiArticleEventsPropTypes.viewAtPublisher,
};

DoiArticlePreviewActions.defaultProps = {
  viewAtPublisherEventData: undefined,
};
